<template>
	<footer>
		<div class="footer">
			<div class="fot_box">
				<div class="appdw_box">
					<div class="img_box">
						<img src="../../public/images/icon_tk_foot_m.png">
					</div>
					<div class="dw_box">
						<div class="dw_title">莘知教育APP</div>
						<div class="dw_Small">编制考试就用莘知教育APP</div>
						<div class="dw_btns">
							<div class="dw_btn" @click="appDownload('iphone')"><img src="../../public/images/icon_tk_foot_ios.png" >苹果下载</div>
							<div class="dw_btn" @click="appDownload('andord')"><img src="../../public/images/icon_tk_foot_anz.png" >安卓下载</div>
						</div>
					</div>
				</div>
				<div class="fwh_box">
					<div class="img_bos">
						<p>服务号</p>
						<div>
							<img src="../../public/images/fwh.jpg" >
						</div>
					</div>
					<div class="img_bos">
						<p>订阅号</p>
						<div>
							<img src="../../public/images/dyh.jpg" >
						</div>
					</div>
				</div>
				<div class="address_box">
					<div class="phone">
						<div class="yuan"><img src="../../public/images/icon_phonea.png" alt=""></div>
						<div>
							<p class="small">客服咨询</p>
							<p class="big">400-6655-517</p>
						</div>
					</div>
					<div class="address">
						<div class="yuan"><img src="../../public/images/icon_add.png" alt=""></div>
						<div>
							<p class="small">联系地址</p>
							<p class="big">重庆市渝中区大坪正街118号</p>
						</div>
					</div>
				</div>
			</div>
			<p><a href="https://www.sz517.com/know/law.html"  target="blank" >法律声明</a>&nbsp|&nbsp<a href="https://www.sz517.com/know/contact.html" target="blank">联系我们</a> |&nbsp<a  href="javasrcipt:void(0)">莘知公益</a> |&nbsp<a  href="https://www.sz517.com/know/feedback.html" target="blank">意见反馈</a> |&nbsp<a  href="javasrcipt:void(0)"> 媒体关注</a> |&nbsp<a href="https://www.sz517.com/know/synopsis.html" target="blank">莘知简介</a> |&nbsp<a href="https://www.sz517.com/know/honor.html" target="blank"> 莘知荣誉</a> |&nbsp<a href="javascrpit:void(0)">网站地图</a>    </p>
			<p>
				Copyright©2020 莘知教育 .All Rights Reserved
				<a href="http://beian.miit.gov.cn" target="_blank" rel="nofollow">渝ICP备18013494号-1</a>&nbsp;&nbsp;
				<a target="_blank" rel="nofollow" href="http://www.beian.gov.cn"><img width="16"
						src="https://www.sz517.com/static/home/images/gawb.png" />&nbsp;渝公网安备 50010302002746号</a>
			</p>
		</div>
	</footer>
</template>

<script>
	export default {
		name: "",
		data() {
			return {};
		},
		methods:{
			appDownload(type){
				if(type == 'andord'){
					window.open('https://www.sz517.com/know/downloads.html')
				}else{
					window.open('https://www.sz517.com/know/downloads.html')
				}
			}
		}
	};
</script>

<style scoped lang="scss">
	footer {
		width: 100%;
		/* height: 60px; */
		background: #fff;
		line-height: 60px;
	}

	.footer {
		width: 1200px;
		margin: 0 auto;
		color: #999;
		text-align: center;
		font-size: 12px;

		.fot_box {
			display: flex;
			align-items: center;
			justify-content: flex-start;
			border-bottom: 1px solid #e8e8e8;
			padding: 30px 0;

			.appdw_box {
				display: flex;
				align-items: center;
				justify-content: space-between;
				border-right: 1px solid #e8e8e8;
				padding-right: 45px;
				.img_box{
					padding: 15px;
					border: 1px solid #EBEBEB;
					border-radius: 6px;
				}
				.dw_box{
					// flex: 1;
					line-height: normal;
					padding-left: 22px;
					text-align: left;
					.dw_title{
						color: #333;
						font-size: 22px;
						font-weight: bold;
					}
					.dw_Small{
						color: #666;
						font-size: 14px;
						margin-top: 15px;
					}
					.dw_btns{
						display: flex;
						margin-top: 30px;
						align-items: center;
						justify-content: space-between;
						.dw_btn{
							cursor:pointer;
							width: 120px;
							height: 36px;
							background: #FFFFFF;
							border: 1px solid #FF5764;
							border-radius: 5px;
							color: #FF5764;
							display: flex;
							align-items: center;
							justify-content: center;
							margin-right: 16px;
							img{
								margin-right: 9px;
							}
						}
					}
				}
			}
			// .
			.fwh_box{
				display: flex;
				width: 250px;
				align-items: center;
				justify-content: space-between;
				padding: 0 60px;
				border-right: 1px solid #e8e8e8;
				.img_bos{
					p{
						font-size: 16px;
						font-weight: bold;
						color: #333;
						line-height: 30px;
					}
					div{
						padding: 10px;
						border: 1px solid #e8e8e8;
						border-radius: 6px;
						img{
							width: 80px;
							height: 80px;
						}
					}
				}
			}
			.address_box{
				line-height: normal;
				padding-left: 60px;
				text-align: left;
				.phone,.address{
					display: flex;
					justify-content: flex-start;
					align-items: center;
					.yuan{
						display: flex;
						align-items: center;
						justify-content: center;
						background: #F2F2F2;
						width: 40px;
						height: 40px;
						border-radius: 50%;
						margin-right: 15px;
					}
					.small{
						font-size: 14px;
						color: #333;
						font-weight: bold;
					}
					.big{
						font-size: 20px;
						color: #333;
					}
				}
				.address{
					margin-top: 35px;
					.big{
						font-size: 16px;
						color: #333;
					}
				}
			}
		}
	}

	.footer a:hover {
		color: #e60012;
	}
</style>
